import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { DeviceVariant } from 'modules/it_management/components/DeviceVariantSelector/types'
import { DeviceVariantRadio } from 'modules/it_management/components/DeviceVariantSelector/DeviceVariantRadio'
import { DeviceVariantSelect } from 'modules/it_management/components/DeviceVariantSelector/DeviceVariantSelect'
import { DeviceVariantColor } from 'modules/it_management/components/DeviceVariantSelector/DeviceVariantColor'
import { F0Button } from '@factorialco/f0-react'

export interface DeviceVariantSelectorProps {
  settings: DeviceVariant[]
  defaultValues?: Partial<Record<DeviceVariant['id'], string>>
  onSubmit: () => void
}

export const DeviceVariantSelector: React.FC<DeviceVariantSelectorProps> = ({
  settings,
  defaultValues = {},
  onSubmit,
}) => {
  const [selectedVariants, setSelectedVariants] = React.useState(defaultValues)
  const handleVariantChange = (variantId: string, value: string) => {
    setSelectedVariants((prev) => ({ ...prev, [variantId]: value }))
  }

  const isSubmitDisabled = settings.some((variant) => !selectedVariants[variant.id])
  const handleOnSubmit = () => {
    if (isSubmitDisabled) return
    onSubmit?.()
  }

  const renderVariantSelector = (variant: DeviceVariant) => {
    switch (variant.type) {
      case 'radio':
        return (
          <DeviceVariantRadio
            variant={variant}
            value={selectedVariants[variant.id]}
            onChange={(value) => handleVariantChange(variant.id, value)}
          />
        )
      case 'select':
        return (
          <DeviceVariantSelect
            variant={variant}
            value={selectedVariants[variant.id]}
            onChange={(value) => handleVariantChange(variant.id, value)}
          />
        )
      case 'color-select':
        return (
          <DeviceVariantColor
            variant={variant}
            value={selectedVariants[variant.id]}
            onChange={(value) => handleVariantChange(variant.id, value)}
          />
        )
      default:
        return null
    }
  }

  return (
    <Box paddingLeft="s12" width="s300">
      {settings.map((variant: DeviceVariant) => (
        <Box key={variant.id} paddingBottom="s24">
          {renderVariantSelector(variant)}
        </Box>
      ))}

      <F0Button
        label="Request device"
        onClick={handleOnSubmit}
        disabled={isSubmitDisabled}
        size="lg"
        variant="default"
      />
    </Box>
  )
}
